import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";

function AddToCart() {
  const { cart, removeFromCart, totalPrice, updateQuantity } = useCart();
  const navigate = useNavigate();

  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    localStorage.setItem("cartCount", cartCount.toString());
  }, [cartCount]);

  const handleCheckout = () => {
    if (cart.length === 0) return;
    navigate("/checkout");
  };

  const formatPrice = (amount) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "ETB",
    }).format(amount);

  const handleDecrease = (item) => {
    if (item.quantity > 1) {
      updateQuantity(item.variantId, item.quantity - 1); // ✅ FIXED
    }
  };

  const handleIncrease = (item) => {
    if (
      item.availableQuantity == null ||
      item.quantity < item.availableQuantity
    ) {
      updateQuantity(item.variantId, item.quantity + 1); // ✅ FIXED
    }
  };

  return (
    <div className="container py-3 pb-5">
      <h4 className="fw-bold mb-3">Your Cart</h4>

      {cart.length === 0 ? (
        <div className="alert alert-light text-center">Your cart is empty</div>
      ) : (
        <>
          {/* ================= DESKTOP TABLE ================= */}
          <div className="table-responsive d-none d-md-block">
            <table className="table align-middle">
              <thead className="table-light">
                <tr>
                  <th>Product</th>
                  <th className="text-center">Quantity</th>
                  <th>Price</th>
                  <th>Subtotal</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item) => (
                  <tr key={item.variantId}>
                    <td className="fw-semibold">{item.productName}</td>
                    <td className="text-center">
                      <div className="d-inline-flex align-items-center">
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => handleDecrease(item)}
                          disabled={item.quantity <= 1}
                        >
                          −
                        </button>

                        <span className="mx-3 fw-semibold">
                          {item.quantity}
                        </span>

                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => handleIncrease(item)}
                          disabled={
                            item.availableQuantity != null &&
                            item.quantity >= item.availableQuantity
                          }
                        >
                          +
                        </button>
                      </div>
                    </td>
                    <td>{formatPrice(item.price)}</td>
                    <td>{formatPrice(item.price * item.quantity)}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => removeFromCart(item.variantId)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}

                <tr>
                  <td colSpan="3" className="text-end fw-bold">
                    Total
                  </td>
                  <td className="fw-bold">{formatPrice(totalPrice)}</td>
                  <td />
                </tr>
              </tbody>
            </table>
          </div>

          {/* ================= MOBILE CARDS ================= */}
          <div className="d-md-none">
            {cart.map((item) => (
              <div key={item.variantId} className="card mb-3 shadow-sm">
                <div className="card-body">
                  <h6 className="fw-semibold mb-2">{item.productName}</h6>

                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Price</span>
                    <span>{formatPrice(item.price)}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted">Quantity</span>

                    <div className="btn-group">
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => handleDecrease(item)}
                        disabled={item.quantity <= 1}
                      >
                        −
                      </button>

                      <span className="btn btn-light fw-semibold">
                        {item.quantity}
                      </span>

                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => handleIncrease(item)}
                        disabled={
                          item.availableQuantity != null &&
                          item.quantity >= item.availableQuantity
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between fw-semibold">
                    <span>Subtotal</span>
                    <span>{formatPrice(item.price * item.quantity)}</span>
                  </div>

                  <button
                    className="btn btn-sm btn-link text-danger px-0 mt-2"
                    onClick={() => removeFromCart(item.variantId)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* ================= CHECKOUT BAR ================= */}
      {cart.length > 0 && (
        <div className="sticky-bottom bg-white border-top p-3 d-md-none">
          <div className="d-flex justify-content-between fw-bold mb-2">
            <span>Total</span>
            <span>{formatPrice(totalPrice)}</span>
          </div>

          <button className="btn btn-primary w-100" onClick={handleCheckout}>
            Proceed to Checkout
          </button>
        </div>
      )}

      {/* Desktop checkout button */}
      {cart.length > 0 && (
        <div className="d-none d-md-flex justify-content-end mt-3">
          <button className="btn btn-primary" onClick={handleCheckout}>
            Proceed to Checkout
          </button>
        </div>
      )}
    </div>
  );
}

export default AddToCart;
